import file from './file';
import pdf from './pdf';
// import session from './session';
import geolocation from './geolocation';
import keyboard from './keyboard';

export default {
    file,
    pdf,
    // session,
    geolocation,
    keyboard
};
